import React, { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import Tooltip from '@lingxi-common-component/sirius-ui/Tooltip';
import debounce from 'lodash/debounce';
import style from './ellipsisTooltip.module.scss';
const EllipsisTooltip = props => {
    const { className, children, textColor, overlayClassName, placement, zIndex, contentType = 'text', contentClassName = '' } = props;
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const parentRef = useRef(null);
    const mirrorRef = useRef(null);
    useEffect(() => {
        let timeout = null;
        let resizeObserver = null;
        timeout = setTimeout(() => {
            if (parentRef.current && mirrorRef.current) {
                resizeObserver = new ResizeObserver(debounce(() => {
                    if (parentRef.current && mirrorRef.current) {
                        const parentWidth = parentRef.current.getBoundingClientRect().width;
                        const mirrorWidth = mirrorRef.current.getBoundingClientRect().width;
                        setTooltipVisible(parentWidth < mirrorWidth);
                    }
                }, 300));
                resizeObserver.observe(parentRef.current);
            }
        });
        return () => {
            timeout && clearTimeout(timeout);
            resizeObserver && resizeObserver.disconnect();
        };
    }, [children]);
    const renderContent = () => {
        if (contentType === 'html') {
            return React.createElement("span", { className: classnames(style.baseColor, textColor), dangerouslySetInnerHTML: { __html: children } });
        }
        if (React.isValidElement(children)) {
            return React.cloneElement(children, {
                className: classnames(style.baseColor, textColor),
            });
        }
        return children;
    };
    return (React.createElement("span", { className: classnames(style.ellipsisTooltip, className), ref: parentRef },
        tooltipVisible ? (React.createElement(Tooltip, { placement: placement, zIndex: zIndex, overlayClassName: overlayClassName, title: renderContent() }, contentType === 'html' ? (React.createElement("span", { dangerouslySetInnerHTML: { __html: children }, className: classnames(style.ellipsisTooltipContent, contentClassName, 'sirius-no-drag') })) : (React.createElement("span", { className: classnames(style.ellipsisTooltipContent, contentClassName, 'sirius-no-drag') }, children)))) : (React.createElement("span", { className: classnames(style.ellipsisTooltipContent, contentClassName, 'sirius-no-drag') }, children)),
        contentType === 'html' ? (React.createElement("span", { dangerouslySetInnerHTML: { __html: children }, className: style.ellipsisTooltipMirror, ref: mirrorRef })) : (React.createElement("span", { className: style.ellipsisTooltipMirror, ref: mirrorRef }, children))));
};
EllipsisTooltip.defaultProps = {};
export default EllipsisTooltip;
